module.exports = __webpack_public_path__ + "static/media/integral_card_4.345f6764.png";